import { ApiSet, BaseResponse, useDownloadApi } from 'utils/network/api_hooks'
import { Form } from 'utils/hooks'
import { CraifHttpClient } from '../utils/network/axios'

export type SalesDetailSearchForm = {
    start?: string
    end?: string
    filterType?: 'post_date' | 'send_date'
}

export function useDownloadSalesDetailApi(searchForm: Form<SalesDetailSearchForm>): ApiSet<BaseResponse> & { execute: () => void } {
    const apiPath = 'sales/detail/export/'
    const api = useDownloadApi<BaseResponse>(new CraifHttpClient(), {
        initialResponse: {},
    })

    const execute = (): void => {
        api.execute(apiPath, `${searchForm.object.start}-${searchForm.object.end}_sales_detail.xlsx`, searchForm.object)
    }

    return { ...api, execute: execute }
}
